module.exports = __webpack_public_path__ + "1-20.png?86251956134b0df84ede7d54d07f33a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-20.png
// module id = 97
// module chunks = 0